<template>
  <div class="text-justify">
    <!-- <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('3')"></h5>
      </legend>
    </div> -->

    <!-- <form-v2-csgas-location-parent :activity="activity" :disabled="disabled" /> -->

    <form-upload-v2-csgas-location-critical-index
      :activity="activity"
      title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
      :subtitle="$store.getters.getTag('3.2.S')"
      :footer="$store.getters.getTag('3.2.F')"
    />

    <!-- <form-v2-csgas-location-physical-index
      :activity="activity"
      :disabled="disabled"
      :title="$store.getters.getTag('3.3.T')"
      :subtitle="$store.getters.getTag('3.3.S')"
      :footer="$store.getters.getTag('3.3.F')"
    /> -->

    <!-- <form-v2-csgas-location-virtual-sites-index
      :activity="activity"
      :disabled="disabled"
      :title="$store.getters.getTag('3.4.T')"
      :subtitle="$store.getters.getTag('3.4.S')"
      :footer="$store.getters.getTag('3.4.F')"
    /> -->

    <!-- <form-v2-csgas-location-certification-activities-index
      :activity="activity"
      :disabled="disabled"
      :title="$store.getters.getTag('3.5.T')"
      :subtitle="$store.getters.getTag('3.5.S')"
      :footer="$store.getters.getTag('3.5.F')"
    /> -->

    <!-- <form-v2-csgas-location-acc-bodies-index
      :activity="activity"
      :disabled="disabled"
      :title="$store.getters.getTag('3.6.T')"
      :subtitle="$store.getters.getTag('3.6.S')"
      :footer="$store.getters.getTag('3.6.F')"
    /> -->
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  created() {
    this.data();
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      return !["100", "112"].includes(this.status);
    },
  },
  methods: {
    data() {
      this.$store.dispatch("getPoliticalDivision");

      if (this.$store.state.accreditation.org) {
        return;
      }

      this.axiosGet(
        `/organizations/index?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.$store.state.accreditation.org = { ...response.data };
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
